<template>
  <table class="table table-details">
    <tr>
      <td style="min-width: 200PX"><label>{{ $t('generic.id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-journey-details', params: {id: details.account_id, journey_id: details.id.String}}">
          {{ details.id.String }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at  | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.operation_ts') }}</label></td>
      <td>{{ details.operation_ts  | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.business_day') }}</label></td>
      <td>{{ details.business_day  | dateOnly }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.account_id') }}</label></td>
      <td>{{ details.account_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.account_type') }}</label></td>
      <td>{{ details.account_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.discount_id') }}</label></td>
      <td>{{ details.discount_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.fare_municipality_id') }}</label></td>
      <td>{{ details.fare_municipality_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.charge') }}</label></td>
      <td>{{ details.charge | price}}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.ticket_type') }}</label></td>
      <td>{{ details.ticket_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.journey_type') }}</label></td>
      <td>{{ details.journey_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.trip_ends_at') }}</label></td>
      <td>{{ details.trip_ends_at  | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.previous_journey_id') }}</label></td>
      <td v-if="details.previous_journey_id.Valid">
        <router-link
          :to="{name: 'account-journey-details', params: {id: details.account_id, journey_id: details.previous_journey_id.String}}">
          {{ details.previous_journey_id.String }}
        </router-link>
      </td>
      <td v-else></td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.month_ticket_id') }}</label></td>
      <td v-if="details.month_ticket_id.Valid">{{ details.month_ticket_id.String }}</td>
      <td v-else></td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.account_season_ticket_id') }}</label></td>
      <td>
        <span v-if="details.account_season_ticket_id">
        <router-link
          :to="{name: 'account-season-ticket', params: {id: details.account_id, season_ticket_id: details.account_season_ticket_id}}">
          {{ details.account_season_ticket_id }}
        </router-link>
      </span>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.season_ticket_id') }}</label></td>
      <td>
      <span v-if="details.season_ticket_id">
        <router-link :to="{name: 'season_ticket', params: {id: details.season_ticket_id}}">
          {{ details.season_ticket_id }}
        </router-link>
      </span>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.operator_id') }}</label></td>
      <td>{{ details.operator_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.mapping_id') }}</label></td>
      <td>{{ details.mapping_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.garage_number') }}</label></td>
      <td>{{ details.garage_number }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.vehicle_type') }}</label></td>
      <td>{{ details.vehicle_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.route') }}</label></td>
      <td>{{ details.route }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.schedule') }}</label></td>
      <td>{{ details.schedule }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.driver_initials') }}</label></td>
      <td>{{ details.driver_initials }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.driver_id') }}</label></td>
      <td>{{ details.driver_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.time_card') }}</label></td>
      <td>{{ details.time_card }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.fare_group_id') }}</label></td>
      <td>{{ details.fare_group_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.fare_id') }}</label></td>
      <td>{{ details.fare_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.async') }}</label></td>
      <td> {{ details.async | bool }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.trip_id') }}</label></td>
      <td> {{ details.trip_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.stop_id') }}</label></td>
      <td> {{ details.stop_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.outdated_vi_received_at') }}</label></td>
      <td> {{ details.outdated_vi_received_at | nullableTime }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.trip_index') }}</label></td>
      <td> {{ details.trip_index }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.current_stop_index') }}</label></td>
      <td> {{ details.current_stop_index }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('journey.details.taps') }}</label></td>
      <td>
        <span v-if="withTaps===true">
          <taps-table :table-data="details.taps"/>
        </span>
        <span v-else><router-link
          :to="{name: 'account-journey-details', params: {id: details.account_id, journey_id: details.id.String}}">
              <i class="tim-icons icon-double-right"></i>
            </router-link>
        </span>
      </td>
    </tr>
  </table>
</template>
<script>
import TapsTable from '../Tap/TapsTable'

export default {
  name: 'journeyDetails',
  components: {
    TapsTable
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
    withTaps: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {}
};
</script>
<style></style>
